/**
 * 隠れスキル診断ポップアップ。
 * PrimeComplete / MyPageYagiprime から open、App 配下の SkillDiagnosisPopup が購読。
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

export type SkillDiagnosisOpenOptions = {
  showSkip?: boolean
}

export const useSkillDiagnosisPopupStore = defineStore(
  'skillDiagnosisPopup',
  () => {
    const visible = ref(false)
    const showSkipOption = ref(false)

    function open(options?: SkillDiagnosisOpenOptions | null) {
      showSkipOption.value = !!(options && options.showSkip)
      visible.value = true
    }

    function close() {
      visible.value = false
    }

    function setVisible(value: boolean) {
      visible.value = value
    }

    return {
      visible,
      showSkipOption,
      open,
      close,
      setVisible
    }
  }
)
